import {inject, Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';

@Pipe({standalone: true, name: 'registrationCodePipe'})
export class RegistrationCodePipe implements PipeTransform
{
  private datePipe = inject(DatePipe);
  private translate = inject(TranslateService);

  transform(code: string, validTo?: Date): string
  {
    if (code?.length === 6)
      return code.substring(0, 3) + '-' + code.substring(3) + this.getValidToStr(validTo);
    return code + this.getValidToStr(validTo);
  }

  private getValidToStr(validTo?: Date): string
  {
    if (validTo)
      return ' (' + this.translate.instant('VALID_TO') + ' ' + this.datePipe.transform(validTo, 'short') + ')';
    else return '';
  }
}
